var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#C5D5EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8064 5.43625C16.8064 5.43625 18.1015 4.93125 17.9936 6.15768C17.9576 6.66269 17.6339 8.43019 17.382 10.342L16.5186 16.0052C16.5186 16.0052 16.4467 16.8349 15.7991 16.9792C15.1516 17.1234 14.1803 16.4742 14.0004 16.3299C13.8565 16.2217 11.3023 14.5984 10.4029 13.8049C10.151 13.5884 9.86323 13.1556 10.4388 12.6506L14.2162 9.04342C14.6479 8.61055 15.0796 7.60055 13.2809 8.82699L8.24437 12.2538C8.24437 12.2538 7.66877 12.6145 6.58953 12.2899L4.25114 11.5684C4.25114 11.5684 3.38774 11.0274 4.86272 10.4863C8.46023 8.79089 12.8852 7.05945 16.8064 5.43625Z",
    fill: "#003249"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.f931dbdf4607f1ff5f4c90c49aa9f792.svg";
export { ForwardRef as ReactComponent };